import React from "react";

export default function AdhanHero() {
  return (
    <div className="w-full h-lvh flex justify-center items-center">
      <div className="max-w-[1200px]">
        <div className="grid gird-cols-1 md:grid-cols-2  px-2 py-4 items-center">
          <h3 className="text-4xl font-black text-center md:order-last">
            Adhan : Your Comprehensive Islamic Prayer Times Companion App
          </h3>

          <div className="flex items-center justify-center pt-4">
            <img
              width={200}
              src="/asset/adhan/screen/adhan-main.webp"
              alt="List of City"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
